module.exports = __webpack_public_path__ + "assets/f06c24d9a0f81f5a70352d11c11ce324.png";